const { buildWhatsappLink } = require("./constants");

const makeCta = (label, message, source) => ({
  label,
  href: buildWhatsappLink(message, source),
});

const commonProcess = [
  "Entendemos o contexto, prioridades e restrições da empresa.",
  "Definimos a solução mínima que gera valor sem criar complexidade desnecessária.",
  "Implementamos, medimos e deixamos uma base preparada para evoluir.",
];

const servicePages = [
  {
    path: "/criacao-de-sites",
    title: "Criação de Sites Profissionais em Portugal | BezierClick",
    description:
      "Criamos websites rápidos, modernos e preparados para SEO e conversão. Desenvolvimento de sites profissionais para empresas em Portugal.",
    h1: "Criação de sites profissionais para empresas",
    eyebrow: "Websites empresariais",
    intro:
      "Websites rápidos, modernos e construídos para transformar visitantes em oportunidades de negócio.",
    secondaryCta: {
      label: "Ver projetos",
      href: "/projetos",
    },
    problemHeading: "O seu website deveria trabalhar pela sua empresa.",
    problem:
      "Muitas empresas têm um site que apresenta a marca, mas não explica bem o valor, não aparece nas pesquisas certas, carrega devagar em mobile e não ajuda a equipa comercial a receber pedidos qualificados.",
    problemPoints: [
      "Website desatualizado",
      "Carregamento lento",
      "Pouca presença no Google",
      "Experiência mobile fraca",
      "Ausência de conversão",
      "Dificuldade para atualizar",
      "Falta de métricas",
      "Dependência excessiva das redes sociais",
    ],
    solution:
      "A BezierClick estrutura websites com mensagem B2B, performance, SEO técnico, CTAs claros e integração com canais de contacto para ligar presença digital a resultados comerciais.",
    benefits: [
      "Design responsivo",
      "SEO técnico",
      "Performance",
      "Google Analytics",
      "Search Console",
      "WhatsApp",
      "Formulários",
      "Segurança",
      "Conversão",
      "Manutenção disponível",
    ],
    websiteTypes: [
      {
        title: "Website empresarial",
        desc: "Base comercial para apresentar empresa, serviços, prova, contacto e posicionamento.",
      },
      {
        title: "Landing page",
        desc: "Página focada numa campanha, oferta ou serviço com objetivo claro de contacto.",
      },
      {
        title: "Website de serviços",
        desc: "Estrutura para explicar áreas de atuação e captar procura com intenção comercial.",
      },
      {
        title: "Website preparado para evoluir",
        desc: "Arquitetura que pode crescer para SEO local, automações, integrações e Tech Partner.",
      },
    ],
    valueComparison: {
      heading: "Nem todos os websites são construídos com o mesmo objetivo.",
      rows: [
        {
          conventional: "Apenas presença online",
          bezierclick: "Pensado para gerar oportunidades",
        },
        {
          conventional: "Estrutura genérica",
          bezierclick: "Estrutura orientada ao negócio",
        },
        {
          conventional: "SEO posterior",
          bezierclick: "SEO desde a construção",
        },
        {
          conventional: "Sem métricas",
          bezierclick: "Conversões monitorizadas",
        },
        {
          conventional: "Termina na entrega",
          bezierclick: "Pode evoluir continuamente",
        },
        {
          conventional: "Ferramenta isolada",
          bezierclick: "Pode integrar o ecossistema da empresa",
        },
      ],
    },
    relatedProjectPaths: ["/projetos/veentto-vagos"],
    howItWorks: [
      "Entendemos o negócio, o público, os serviços e o objetivo comercial do website.",
      "Definimos arquitetura, mensagem, páginas, investimento e prioridades antes de construir.",
      "Desenvolvemos a experiência com foco em mobile, performance, SEO técnico e clareza.",
      "Validamos conteúdo, formulários, WhatsApp, analytics, metadata e comportamento em dispositivos.",
      "Publicamos o website e deixamos a base preparada para monitorização e melhorias futuras.",
      "A BezierClick pode continuar a acompanhar manutenção, SEO, automações e evolução Tech Partner.",
    ],
    features: ["Arquitetura de páginas", "Copywriting B2B", "Formulários", "WhatsApp", "Open Graph", "Schema.org"],
    faq: [
      {
        question: "Quanto custa criar um website?",
        answer: "Depende do objetivo, número de páginas, conteúdo, integrações e nível de acompanhamento. Os planos da BezierClick apresentam pontos de partida e a proposta final é definida depois de perceber o escopo.",
      },
      {
        question: "Quanto tempo demora?",
        answer: "Depende da dimensão e do conteúdo, mas um website empresarial simples costuma avançar por etapas curtas de estratégia, desenvolvimento, validação e publicação.",
      },
      {
        question: "O website será otimizado para Google?",
        answer: "Sim. A base inclui estrutura semântica, metadata, performance, URLs claras, schema quando adequado e preparação para evoluir com páginas de serviço, SEO local e conteúdos.",
      },
      {
        question: "Posso atualizar o conteúdo?",
        answer: "Sim. A solução pode ser preparada para atualização de conteúdos conforme o modelo escolhido e o nível de manutenção contratado.",
      },
      {
        question: "O alojamento está incluído?",
        answer: "O alojamento pode ser incluído nos planos de manutenção e suporte recorrente, ou tratado como parte separada conforme a necessidade da empresa.",
      },
      {
        question: "Existe manutenção depois da entrega?",
        answer: "Sim. O website pode evoluir para manutenção, melhorias contínuas, SEO, automações, integrações e acompanhamento Tech Partner.",
      },
    ],
    cta: makeCta(
      "Quero um novo website",
      "Olá, encontrei a BezierClick através da página de criação de sites e gostaria de falar sobre um projeto.",
      "service_criacao_de_sites"
    ),
  },
  {
    path: "/criacao-de-sites/sites-empresariais",
    title: "Sites empresariais para PMEs | BezierClick",
    description:
      "Sites empresariais para PMEs em Portugal que precisam explicar serviços, gerar confiança, captar contactos e apoiar equipas comerciais.",
    h1: "Sites empresariais para PMEs",
    eyebrow: "Sites B2B",
    intro:
      "Desenvolvemos sites empresariais focados em credibilidade, clareza comercial e geração de pedidos qualificados.",
    problem:
      "Um site empresarial fraco obriga potenciais clientes a procurar informação noutros canais, reduz confiança e cria atrito antes do primeiro contacto.",
    solution:
      "Organizamos mensagem, serviços, prova, contactos e CTAs para que o site funcione como uma base comercial estável para prospecção, Google e referências.",
    benefits: ["Clareza de serviços", "Confiança", "SEO base", "Mobile-first", "Contacto rápido", "Conteúdo comercial"],
    howItWorks: commonProcess,
    features: ["Home", "Serviços", "Empresa", "Projetos", "Contacto", "Analytics"],
    faq: [
      {
        question: "Um site empresarial precisa de muitas páginas?",
        answer: "Não necessariamente. A estrutura deve refletir serviços, objeções e prioridades comerciais, evitando páginas sem conteúdo útil.",
      },
      {
        question: "Podemos começar simples e evoluir depois?",
        answer: "Sim. A recomendação é publicar uma base clara e expandir com serviços, SEO local, cases e insights quando houver conteúdo real.",
      },
      {
        question: "O site pode integrar WhatsApp e formulários?",
        answer: "Sim. Os canais de contacto podem ser ligados a tracking e automações para medir oportunidades.",
      },
    ],
    cta: makeCta(
      "Pedir orçamento",
      "Olá! Quero falar sobre um site empresarial para a minha PME.",
      "service_sites_empresariais"
    ),
  },
  {
    path: "/criacao-de-sites/landing-pages",
    title: "Landing pages para campanhas | BezierClick",
    description:
      "Landing pages para campanhas, serviços e lançamentos B2B, com copy clara, tracking, WhatsApp e foco em conversão sem distrações.",
    h1: "Landing pages para campanhas e geração de leads",
    eyebrow: "Conversão",
    intro:
      "Criamos landing pages focadas numa ação específica: gerar contacto, pedido de orçamento ou conversa comercial.",
    problem:
      "Campanhas enviadas para páginas genéricas perdem intenção, confundem visitantes e tornam difícil perceber quais canais geram oportunidades.",
    solution:
      "A BezierClick cria páginas focadas num público, problema e CTA, com estrutura de copy, tracking e integração para medir cada contacto recebido.",
    benefits: ["Mensagem focada", "Mais conversão", "Tracking", "WhatsApp", "Formulários", "Publicação rápida"],
    howItWorks: commonProcess,
    features: ["Hero orientado a oferta", "Benefícios", "FAQ", "CTA único", "Eventos GA4", "SEO básico"],
    faq: [
      {
        question: "Uma landing page substitui um website?",
        answer: "Não sempre. Ela é melhor para campanhas e ofertas específicas; um website completo serve como base institucional e SEO.",
      },
      {
        question: "Podemos medir cliques e contactos?",
        answer: "Sim. A página pode incluir eventos de WhatsApp, formulário, email, telefone e pedidos de orçamento.",
      },
      {
        question: "A landing page pode virar uma página de serviço depois?",
        answer: "Sim. Se a oferta for permanente, a página pode evoluir para uma página SEO mais completa.",
      },
    ],
    cta: makeCta(
      "Pedir orçamento",
      "Olá! Quero pedir orçamento para uma landing page de campanha.",
      "service_landing_pages"
    ),
  },
  {
    path: "/criacao-de-sites/redesign",
    title: "Redesign de websites empresariais | BezierClick",
    description:
      "Redesign de websites empresariais para melhorar clareza, performance, SEO, mobile e conversão sem perder identidade de marca.",
    h1: "Redesign de websites que precisam vender melhor",
    eyebrow: "Redesign",
    intro:
      "Atualizamos websites existentes para comunicar melhor, carregar mais rápido e apoiar objetivos comerciais reais.",
    problem:
      "Sites antigos acumulam problemas de mensagem, tecnologia, performance e navegação, prejudicando confiança e dificultando a aquisição de leads.",
    solution:
      "Auditamos o que deve ser preservado, reorganizamos conteúdo e implementamos uma experiência mais clara sem fazer redesign por vaidade.",
    benefits: ["Melhor UX", "Mais clareza", "Performance", "SEO técnico", "Mobile", "Tracking"],
    howItWorks: commonProcess,
    features: ["Auditoria", "Reestruturação", "Migração de conteúdo", "Redirects", "Novos CTAs", "Medição"],
    faq: [
      {
        question: "O redesign muda tudo?",
        answer: "Não. A prioridade é preservar o que funciona e melhorar estrutura, conteúdo, performance e conversão.",
      },
      {
        question: "As URLs antigas são mantidas?",
        answer: "Sempre que possível. Quando há mudança necessária, devem ser preparados redirects para proteger SEO.",
      },
      {
        question: "Dá para melhorar sem perder a identidade visual?",
        answer: "Sim. O redesign pode reforçar a marca sem descaracterizar cores, tipografia e personalidade.",
      },
    ],
    cta: makeCta(
      "Pedir orçamento",
      "Olá! Quero avaliar um redesign para o website da minha empresa.",
      "service_redesign"
    ),
  },
  {
    path: "/ecommerce",
    title: "E-commerce para empresas | BezierClick",
    description:
      "Desenvolvimento de e-commerce para empresas que querem vender online com operação, pagamentos, tracking e integrações preparadas para crescer.",
    h1: "E-commerce para empresas que querem vender online",
    eyebrow: "Venda online",
    intro:
      "Criamos lojas online com foco em catálogo, checkout, operação e medição de oportunidades comerciais.",
    problem:
      "Vender online exige mais do que colocar produtos numa página; sem operação e tracking, encomendas, campanhas e clientes tornam-se difíceis de gerir.",
    solution:
      "A BezierClick estrutura ecommerce com experiência de compra, pagamentos, analytics e integrações adequadas ao estágio comercial da empresa.",
    benefits: ["Catálogo claro", "Pagamentos", "Gestão de encomendas", "Tracking", "SEO", "Integrações"],
    howItWorks: commonProcess,
    features: ["Produtos", "Checkout", "Métodos de pagamento", "Emails", "Analytics", "Integração logística"],
    faq: [
      {
        question: "O e-commerce pode começar pequeno?",
        answer: "Sim. É melhor começar com catálogo e operação controlados do que lançar uma estrutura complexa sem validação.",
      },
      {
        question: "Podemos integrar pagamentos portugueses?",
        answer: "Sim. A solução pode incluir métodos adequados ao mercado português, conforme a plataforma escolhida.",
      },
      {
        question: "A loja pode ligar a ferramentas externas?",
        answer: "Sim. Faturação, transportadoras, CRM e campanhas podem ser integradas conforme necessidade.",
      },
    ],
    cta: makeCta(
      "Pedir orçamento",
      "Olá! Quero falar sobre uma solução de e-commerce para a minha empresa.",
      "service_ecommerce"
    ),
  },
  {
    path: "/seo",
    title: "SEO para empresas em Portugal | BezierClick",
    description:
      "SEO técnico, conteúdo e SEO local para empresas em Portugal que querem aparecer melhor no Google e transformar pesquisa em oportunidades.",
    h1: "SEO para empresas que querem aparecer melhor no Google",
    eyebrow: "SEO orgânico e local",
    intro:
      "Trabalhamos SEO como parte da estratégia comercial: páginas úteis, técnica sólida e intenção de procura bem definida.",
    problem:
      "Empresas com bom serviço muitas vezes não aparecem nas pesquisas certas, dependem apenas de indicação ou pagam tráfego sem construir presença orgânica.",
    solution:
      "A BezierClick organiza arquitetura, metadata, conteúdo, páginas locais e performance para criar uma base de SEO sustentável e mensurável.",
    benefits: ["SEO técnico", "SEO local", "Conteúdo", "Sitemap", "Schema.org", "Pesquisa com intenção"],
    howItWorks: commonProcess,
    features: ["Auditoria SEO", "Arquitetura", "Metadata", "Conteúdo", "Schema", "Search Console"],
    faq: [
      {
        question: "SEO dá resultados imediatos?",
        answer: "SEO é uma construção gradual. A base técnica pode melhorar rápido, mas autoridade e rankings exigem consistência.",
      },
      {
        question: "SEO local é diferente de SEO normal?",
        answer: "Sim. SEO local trabalha procura por região, contexto geográfico, Google Business Profile e páginas com conteúdo regional real.",
      },
      {
        question: "Podemos fazer SEO sem criar páginas vazias?",
        answer: "Sim. A regra é criar páginas apenas quando houver conteúdo útil, intenção clara e ligação comercial verdadeira.",
      },
    ],
    cta: makeCta(
      "Pedir orçamento",
      "Olá! Quero melhorar SEO e presença no Google com a BezierClick.",
      "service_seo"
    ),
  },
  {
    path: "/software-a-medida",
    title: "Software à medida para empresas | BezierClick",
    description:
      "Software à medida para empresas que precisam substituir processos manuais, folhas Excel e ferramentas genéricas por sistemas adaptados ao trabalho real.",
    h1: "Software à medida para processos empresariais",
    eyebrow: "Sistemas internos",
    intro:
      "Criamos sistemas, portais, dashboards e ferramentas internas desenhadas para o processo real da empresa.",
    problem:
      "Quando folhas Excel, mensagens e ferramentas soltas deixam de chegar, a equipa perde tempo, duplica informação e toma decisões com pouca visibilidade.",
    solution:
      "A BezierClick transforma processos empresariais em software simples, evolutivo e focado em reduzir trabalho manual sem criar peso operacional.",
    benefits: ["Processos claros", "Menos Excel", "Dashboards", "Permissões", "Automação", "Escalabilidade"],
    howItWorks: commonProcess,
    features: ["Portal interno", "CRM", "Dashboard", "Gestão de tarefas", "Relatórios", "Integrações"],
    faq: [
      {
        question: "Software à medida é sempre caro?",
        answer: "Não precisa começar grande. O primeiro passo pode ser uma ferramenta pequena para resolver o processo mais crítico.",
      },
      {
        question: "Como evitar criar um sistema demasiado complexo?",
        answer: "Começando pelo fluxo principal, validando com utilizadores e evoluindo apenas quando há necessidade real.",
      },
      {
        question: "O software pode integrar ferramentas existentes?",
        answer: "Sim. Quando faz sentido, ligamos o sistema a website, CRM, email, faturação ou outras ferramentas.",
      },
    ],
    cta: makeCta(
      "Pedir orçamento",
      "Olá! Quero falar sobre software à medida para a minha empresa.",
      "service_software_a_medida"
    ),
  },
  {
    path: "/automacao-empresarial",
    title: "Automação empresarial | BezierClick",
    description:
      "Automação empresarial para reduzir tarefas repetitivas, organizar leads, ligar ferramentas e acelerar operações em PMEs portuguesas.",
    h1: "Automação empresarial para reduzir trabalho manual",
    eyebrow: "Automação",
    intro:
      "Desenhamos automações para captar, qualificar, notificar, responder e organizar processos sem depender de tarefas repetitivas.",
    problem:
      "Equipas ocupadas perdem oportunidades quando precisam copiar dados, lembrar follow-ups e repetir tarefas entre email, WhatsApp, CRM e folhas de cálculo.",
    solution:
      "A BezierClick identifica pontos de fricção e cria fluxos automatizados que poupam tempo, reduzem erro e dão mais previsibilidade à operação.",
    benefits: ["Menos tarefas repetidas", "Follow-up", "Notificações", "CRM", "Relatórios", "Mais velocidade"],
    howItWorks: commonProcess,
    features: ["Lead routing", "Emails automáticos", "WhatsApp", "CRM", "Alertas", "Relatórios"],
    faq: [
      {
        question: "Que processos podem ser automatizados?",
        answer: "Captação de leads, notificações, follow-ups, organização de pedidos, geração de documentos e sincronização entre ferramentas.",
      },
      {
        question: "Automação substitui pessoas?",
        answer: "O objetivo é retirar tarefas repetitivas para que a equipa se concentre em atendimento, venda e decisões.",
      },
      {
        question: "É possível começar com uma automação simples?",
        answer: "Sim. Muitas empresas começam por automatizar um formulário, uma notificação ou um fluxo comercial específico.",
      },
    ],
    cta: makeCta(
      "Pedir orçamento",
      "Olá! Quero automatizar processos da minha empresa com a BezierClick.",
      "service_automacao_empresarial"
    ),
  },
  {
    path: "/inteligencia-artificial",
    title: "Inteligência Artificial para empresas | BezierClick",
    description:
      "Soluções com inteligência artificial para PMEs que querem melhorar atendimento, análise, automação e suporte interno de forma útil e controlada.",
    h1: "Inteligência Artificial aplicada a problemas empresariais",
    eyebrow: "IA para PMEs",
    intro:
      "Implementamos IA quando ela resolve um problema real: responder melhor, organizar informação ou apoiar decisões.",
    problem:
      "Muitas empresas querem usar IA, mas não sabem onde aplicar sem criar ruído, risco ou ferramentas desconectadas do processo diário.",
    solution:
      "A BezierClick desenha soluções com IA integradas ao fluxo da empresa, com objetivos claros, limites definidos e foco em utilidade prática.",
    benefits: ["Atendimento assistido", "Triagem", "Análise de documentos", "Respostas internas", "Automação", "Suporte à equipa"],
    howItWorks: commonProcess,
    features: ["Chat assistido", "Base de conhecimento", "Classificação", "Resumo", "Integrações", "Controlo humano"],
    faq: [
      {
        question: "IA serve para qualquer empresa?",
        answer: "Serve quando há um problema claro. Antes de implementar, avaliamos impacto, risco e esforço.",
      },
      {
        question: "A IA responde diretamente aos clientes?",
        answer: "Pode responder, mas muitas vezes é melhor começar com assistência interna ou triagem com supervisão humana.",
      },
      {
        question: "É necessário treinar modelos próprios?",
        answer: "Nem sempre. Muitas soluções usam modelos existentes com contexto, regras e integrações bem desenhadas.",
      },
    ],
    cta: makeCta(
      "Pedir orçamento",
      "Olá! Quero perceber como aplicar IA na minha empresa.",
      "service_inteligencia_artificial"
    ),
  },
  {
    path: "/integracoes",
    title: "Integrações entre sistemas | BezierClick",
    description:
      "Integrações entre website, CRM, faturação, email, WhatsApp, analytics e ferramentas internas para reduzir trabalho manual e erros.",
    h1: "Integrações entre ferramentas empresariais",
    eyebrow: "Integrações",
    intro:
      "Ligamos sistemas para que informação circule melhor e a equipa deixe de copiar dados manualmente.",
    problem:
      "Quando ferramentas não comunicam, dados ficam duplicados, tarefas dependem de pessoas e a operação perde velocidade e fiabilidade.",
    solution:
      "A BezierClick cria integrações entre website, CRM, faturação, email, WhatsApp, analytics e sistemas internos para melhorar fluxo e visibilidade.",
    benefits: ["Menos erro", "Dados conectados", "Mais velocidade", "Visibilidade", "Automação", "Escala operacional"],
    howItWorks: commonProcess,
    features: ["APIs", "Webhooks", "CRM", "Faturação", "Email", "Dashboards"],
    faq: [
      {
        question: "Que ferramentas podem ser integradas?",
        answer: "Depende das APIs disponíveis. Podemos avaliar CRM, website, formulários, faturação, email, WhatsApp e sistemas internos.",
      },
      {
        question: "Integração é o mesmo que automação?",
        answer: "Não. Integração liga ferramentas; automação usa essa ligação para executar passos ou decisões automaticamente.",
      },
      {
        question: "Como evitam quebrar processos existentes?",
        answer: "Mapeamos o fluxo atual, testamos dados e começamos por integrações controladas antes de expandir.",
      },
    ],
    cta: makeCta(
      "Pedir orçamento",
      "Olá! Quero integrar ferramentas e sistemas da minha empresa.",
      "service_integracoes"
    ),
  },
];

const getServicePageByPath = (path) =>
  servicePages.find((page) => page.path === path) || null;

module.exports = {
  servicePages,
  getServicePageByPath,
};
